module.exports = __webpack_public_path__ + "img/appAsset-agents-avatar-10.17374ba9.jpg";